import React, { useState } from "react";
import "./style.css";
import { Button, Form, Input } from "antd";
import { IoIosEyeOff, IoIosEye } from "react-icons/io";
import { useNavigate } from "react-router-dom";
import { adminLogin } from "../../api/auth";
import { useSelector } from "react-redux";

const Login = () => {
  const { isLoading } = useSelector((state) => state.admin);
  const [form] = Form.useForm();

  const onFinish = async (values) => {
    await adminLogin(values);
  };

  return (
    <div className="auth_container">
      <div className="auth_bg" />
      <h1>Admin Salud Justicia</h1>
      <div className="form_wrapper">
        <h2 style={{ marginBottom: "20px" }}>Login</h2>
        <Form
          layout="vertical"
          form={form}
          onFinish={onFinish}
          requiredMark={false}
          autoComplete="off"
        >
          <Form.Item
            label="Email"
            name="email"
            rules={[
              {
                required: true,
                message: "Required",
              },
            ]}
          >
            <Input type="email" />
          </Form.Item>
          <Form.Item
            label="Password"
            name="password"
            rules={[
              {
                required: true,
                message: "Required",
              },
            ]}
          >
            <Input.Password
              iconRender={(visible) =>
                visible ? (
                  <IoIosEye size={20} style={{ cursor: "pointer" }} />
                ) : (
                  <IoIosEyeOff size={20} style={{ cursor: "pointer" }} />
                )
              }
            />
          </Form.Item>
          <Button
            className="button"
            type="primary"
            loading={isLoading}
            htmlType="submit"
          >
            LOGIN
          </Button>
        </Form>
      </div>
    </div>
  );
};

export default Login;
